/**
 * Aide contextuelle — Réseaux sociaux / Planning éditorial
 */

const socialHelp = {
  '/social/planning': {
    title: 'Planning éditorial',
    user: [
      {
        heading: 'A quoi sert cette page ?',
        content: `Vue analytique de la production éditoriale : volumes de posts, heatmap par jour, répartition par catégorie/canal, objectifs annuels, thèmes dominants. Utile pour piloter la régularité de publication et détecter les trous de calendrier.`,
      },
      {
        heading: 'Sélecteur de période — 3 modes',
        content: `En haut à droite, le toggle propose 3 modes :\n\n**Année** : vue annuelle classique. Chevrons \`<\` / \`>\` pour naviguer.\n**Multi-années** : sélectionnez une plage d'années via les 2 dropdowns. La heatmap s'empile (1 grille par année), les thèmes dominants s'agrègent par année avec onglet "Top global".\n**Période** : sélectionnez une plage personnalisée avec le calendrier (popover). Granularité adaptative : si la plage ≤ 1 an, agrégation mensuelle ; si > 1 an, agrégation annuelle.`,
      },
      {
        heading: 'Heatmap — date utilisée',
        content: `Chaque case = 1 jour. La date suit une cascade de priorité : **published_at** > **scheduled_at** > **created_at**. Pour les articles backfillés en draft (status=draft, published_at=null), c'est donc la **scheduled_at historique** qui positionne le post sur le bon jour — pas la date de création récente.`,
      },
      {
        heading: 'Objectifs masqués en multi/période',
        content: `Les objectifs (réalisé/cible) sont **annuels par construction**. En mode Multi-années ou Période, ils sont masqués avec un message explicite ("Repassez en mode Année pour les visualiser"). Sommer des objectifs annuels n'a pas de sens métier — un objectif raté en 2022 ne se rattrape pas avec une bonne année 2025.`,
      },
      {
        heading: 'Persistance & partage',
        content: `Le mode et la plage sont **persistés dans localStorage** (clé \`social_analytics_range\`) et **reflétés dans l'URL** (\`?mode=multi&from_year=2021&to_year=2026\`). Vous pouvez bookmarker une vue précise ou la partager par lien — au chargement, l'URL prime sur le localStorage.`,
      },
    ],
    admin: [
      {
        heading: 'Endpoint analytics',
        content: `\`GET /api/social/analytics\` accepte 3 formes :\n- \`?year=YYYY\` (legacy, rétro-compatible)\n- \`?from=YYYY-MM-DD&to=YYYY-MM-DD\` (plage custom)\n- (rien) → fallback année courante\n\nValidation : 400 si \`from >= to\`, 400 si span > 3700 jours (~10 ans). Bucketing automatique : \`month\` si span ≤ 366j (12 buckets dans \`by_month\`), \`year\` sinon (N buckets dans \`by_year\`). La heatmap est **toujours** retournée dans \`daily_heatmap_by_year\` (dict indexé par année) ; le champ legacy \`daily_heatmap\` est rempli seulement pour une plage 1-an (sinon null).`,
      },
      {
        heading: 'Alertes (trous ≥ 14j)',
        content: `Les alertes "trous" ne sont calculées que dans l'**année courante** (les trous historiques ne sont pas actionnables). Au max 3 alertes affichées par requête.`,
      },
    ],
  },
};

export default socialHelp;
